import type { CrmObject } from '@/types/crm';
import { getPropertyValue } from '@/types/crm';

/**
 * Extracts the ahoy_updated_at property as a display string, or null when
 * the property is absent. Shared by pipeline card content components so the
 * "Last updated" footer computation stays in one place.
 */
export function getCardUpdatedAt(
  properties: CrmObject['properties']
): string | null {
  const raw = getPropertyValue<unknown>(properties?.ahoy_updated_at);
  return raw !== null && raw !== undefined ? String(raw) : null;
}
